const cards = [
  {
    image: 'https://readdy.ai/api/search-image?query=Breaking%20news%20journalism%20scene%2C%20abstract%20documentary%20style%20with%20warm%20red%20and%20cream%20tones%2C%20floating%20newspaper%20fragments%2C%20dramatic%20soft%20lighting%2C%20editorial%20composition%2C%20modern%20minimalist%20aesthetic&width=800&height=500&seq=card-01&orientation=landscape',
    tag: '社会热点',
    tagColor: 'bg-primary-100 text-primary-700',
    title: '某知名企业高管被曝内部不当行为，公司股价应声下跌',
    desc: '消息人士透露，该企业多名中层管理人员联名举报，涉及财务违规与职场不当行为，目前相关部门已介入调查。',
    time: '3小时前',
    views: '28.6万',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Technology%20industry%20news%20concept%2C%20abstract%20digital%20data%20visualization%2C%20warm%20amber%20and%20cream%20color%20palette%2C%20clean%20minimal%20editorial%20style%2C%20soft%20lighting%2C%20documentary%20photography%20feel&width=800&height=500&seq=card-02&orientation=landscape',
    tag: '科技行业',
    tagColor: 'bg-accent-100 text-accent-700',
    title: '独家：某头部科技公司下一代产品路线图遭内部泄露',
    desc: '一份标注为机密级别的产品规划文件在社交平台流传，涉及未来两年核心产品布局，业内震动。',
    time: '5小时前',
    views: '22.3万',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Entertainment%20industry%20drama%20abstract%20concept%2C%20warm%20lighting%20with%20golden%20accents%2C%20editorial%20style%20photography%2C%20soft%20shadows%2C%20minimalist%20composition%2C%20cream%20and%20warm%20gray%20background&width=800&height=500&seq=card-03&orientation=landscape',
    tag: '娱乐圈',
    tagColor: 'bg-secondary-100 text-secondary-700',
    title: '圈内人爆料：某顶流综艺节目录制现场突发状况，导演组紧急调整',
    desc: '据现场工作人员透露，录制过程中出现意外情况导致节目中断近两小时，节目组已启动应急预案。',
    time: '7小时前',
    views: '35.1万',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Financial%20market%20news%20concept%2C%20abstract%20stock%20market%20data%2C%20warm%20red%20and%20cream%20tones%2C%20editorial%20documentary%20style%2C%20soft%20dramatic%20lighting%2C%20minimalist%20composition&width=800&height=500&seq=card-04&orientation=landscape',
    tag: '金融动态',
    tagColor: 'bg-primary-100 text-primary-700',
    title: '内部邮件曝光：某大型金融机构风控存在重大漏洞',
    desc: '一封据称来自该机构内部风控部门的邮件显示，多个核心风控指标长期处于警戒线以下。',
    time: '9小时前',
    views: '19.8万',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Real%20estate%20market%20news%20concept%2C%20abstract%20building%20silhouette%2C%20warm%20amber%20lighting%2C%20modern%20editorial%20style%2C%20cream%20background%2C%20documentary%20photography%20feel%2C%20soft%20shadows&width=800&height=500&seq=card-05&orientation=landscape',
    tag: '房产楼市',
    tagColor: 'bg-accent-100 text-accent-700',
    title: '爆料：某二线城市即将出台重大楼市调控新政',
    desc: '知情人士称，该城市住建部门已完成新政草案，涉及限购松绑与贷款利率调整，预计下月公布。',
    time: '11小时前',
    views: '16.5万',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Internet%20industry%20trends%20abstract%20concept%2C%20digital%20network%20visualization%2C%20warm%20cream%20and%20red%20tones%2C%20editorial%20documentary%20style%2C%20soft%20lighting%2C%20minimalist%20aesthetic&width=800&height=500&seq=card-06&orientation=landscape',
    tag: '互联网圈',
    tagColor: 'bg-secondary-100 text-secondary-700',
    title: '独家：某社交平台大规模用户数据泄露事件内幕',
    desc: '安全研究人员发现该平台API存在严重漏洞，数千万用户数据面临泄露风险，平台已紧急修复。',
    time: '13小时前',
    views: '41.2万',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Consumer%20rights%20protection%20news%20concept%2C%20abstract%20shopping%20theme%2C%20warm%20golden%20and%20cream%20tones%2C%20editorial%20documentary%20photography%20style%2C%20soft%20lighting%2C%20clean%20minimal%20composition&width=800&height=500&seq=card-07&orientation=landscape',
    tag: '消费维权',
    tagColor: 'bg-primary-100 text-primary-700',
    title: '消费者集体投诉某知名品牌产品质量严重下滑',
    desc: '近一个月内已有超过500名消费者在多个平台投诉同一品牌产品存在质量问题，消协已介入。',
    time: '15小时前',
    views: '13.7万',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="w-full py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 lg:px-8 max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between mb-10 md:mb-14">
          <div>
            <span className="text-xs font-label font-semibold text-primary-500 uppercase tracking-wider">
              热门爆料
            </span>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mt-2">
              热门爆料
            </h2>
            <p className="text-foreground-500 text-sm mt-2">
              全网最受关注的爆料内容，实时更新
            </p>
          </div>
          <a
            href="#updates"
            onClick={(e) => {
              e.preventDefault();
              document.querySelector('#updates')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="text-sm text-primary-500 hover:text-primary-600 font-medium mt-4 sm:mt-0 flex items-center gap-1 cursor-pointer whitespace-nowrap"
          >
            查看更多 <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cards.slice(0, 6).map((card, i) => (
            <article
              key={i}
              className="group rounded-xl bg-background-50 border border-background-200/70 overflow-hidden hover:border-background-300 transition-all cursor-pointer"
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden bg-background-100">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-4 md:p-5">
                <span className={`inline-block px-2.5 py-1 rounded-full text-xs font-medium ${card.tagColor} mb-3`}>
                  {card.tag}
                </span>
                <h3 className="text-base font-semibold text-foreground-900 leading-snug mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {card.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-3">
                  {card.desc}
                </p>
                <div className="flex items-center gap-4 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {card.time}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {card.views}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-6">
          <article
            className="group rounded-xl bg-background-50 border border-background-200/70 overflow-hidden hover:border-background-300 transition-all cursor-pointer flex flex-col sm:flex-row"
          >
            <div className="w-full sm:w-[340px] shrink-0 aspect-[16/10] sm:aspect-auto overflow-hidden bg-background-100">
              <img
                src={cards[6].image}
                alt={cards[6].title}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
            </div>
            <div className="p-4 md:p-6 flex flex-col justify-center flex-1">
              <span className={`inline-block px-2.5 py-1 rounded-full text-xs font-medium ${cards[6].tagColor} mb-3 self-start`}>
                {cards[6].tag}
              </span>
              <h3 className="text-lg font-semibold text-foreground-900 leading-snug mb-2 group-hover:text-primary-600 transition-colors">
                {cards[6].title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed mb-3">
                {cards[6].desc}
              </p>
              <div className="flex items-center gap-4 text-xs text-foreground-400">
                <span className="flex items-center gap-1">
                  <i className="ri-time-line"></i>
                  {cards[6].time}
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-eye-line"></i>
                  {cards[6].views}
                </span>
              </div>
            </div>
          </article>
        </div>
      </div>
    </section>
  );
}